"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _MapProperty = _interopRequireDefault(require("../MapProperty.js"));

var _css = require("../css.js");

var _events = require("../events.js");

var _dom = require("../dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/control/FullScreen
 */


var events = ['fullscreenchange', 'webkitfullscreenchange', 'MSFullscreenChange'];
/**
 * @enum {string}
 */

var FullScreenEventType = {
  /**
   * Triggered after the map entered fullscreen.
   * @event FullScreenEventType#enterfullscreen
   * @api
   */
  ENTERFULLSCREEN: 'enterfullscreen',

  /**
   * Triggered after the map leave fullscreen.
   * @event FullScreenEventType#leavefullscreen
   * @api
   */
  LEAVEFULLSCREEN: 'leavefullscreen'
};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen', import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen'|import("../ObjectEventType").Types, Return>} FullScreenOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {string} [className='ol-full-screen'] CSS class name.
 * @property {string|Text|HTMLElement} [label='\u2922'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|Text|HTMLElement} [labelActive='\u00d7'] Text label to use for the
 * button when full-screen is active.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [activeClassName=className + '-true'] CSS class name for the button
 * when full-screen is active.
 * @property {string} [inactiveClassName=className + '-false'] CSS class name for the button
 * when full-screen is inactive.
 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
 * @property {boolean} [keys=false] Full keyboard access.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {HTMLElement|string} [source] The element to be displayed
 * fullscreen. When not provided, the element containing the map viewport will
 * be displayed fullscreen.
 */

/**
 * @classdesc
 * Provides a button that when clicked fills up the full screen with the map.
 * The full screen source element is by default the element containing the map viewport unless
 * overridden by providing the `source` option. In which case, the dom
 * element introduced using this parameter will be displayed in full screen.
 *
 * When in full screen mode, a close button is shown to exit full screen mode.
 * The [Fullscreen API](https://www.w3.org/TR/fullscreen/) is used to
 * toggle the map in full screen mode.
 *
 * @fires FullScreenEventType#enterfullscreen
 * @fires FullScreenEventType#leavefullscreen
 * @api
 */

var FullScreen =
/** @class */
function (_super) {
  __extends(FullScreen, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function FullScreen(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      element: document.createElement('div'),
      target: options.target
    }) || this;
    /***
     * @type {FullScreenOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {FullScreenOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {FullScreenOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {boolean}
     */

    _this.keys_ = options.keys !== undefined ? options.keys : false;
    /**
     * @private
     * @type {HTMLElement|string|undefined}
     */

    _this.source_ = options.source;
    /**
     * @type {boolean}
     * @private
     */

    _this.isInFullscreen_ = false;
    /**
     * @private
     */

    _this.boundHandleMapTargetChange_ = _this.handleMapTargetChange_.bind(_this);
    /**
     * @private
     * @type {string}
     */

    _this.cssClassName_ = options.className !== undefined ? options.className : 'ol-full-screen';
    /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */

    _this.documentListeners_ = [];
    /**
     * @private
     * @type {Array<string>}
     */

    _this.activeClassName_ = options.activeClassName !== undefined ? options.activeClassName.split(' ') : [_this.cssClassName_ + '-true'];
    /**
     * @private
     * @type {Array<string>}
     */

    _this.inactiveClassName_ = options.inactiveClassName !== undefined ? options.inactiveClassName.split(' ') : [_this.cssClassName_ + '-false'];
    var label = options.label !== undefined ? options.label : "\u2922";
    /**
     * @private
     * @type {Text|HTMLElement}
     */

    _this.labelNode_ = typeof label === 'string' ? document.createTextNode(label) : label;
    var labelActive = options.labelActive !== undefined ? options.labelActive : "\xD7";
    /**
     * @private
     * @type {Text|HTMLElement}
     */

    _this.labelActiveNode_ = typeof labelActive === 'string' ? document.createTextNode(labelActive) : labelActive;
    var tipLabel = options.tipLabel ? options.tipLabel : 'Toggle full-screen';
    /**
     * @private
     * @type {HTMLElement}
     */

    _this.button_ = document.createElement('button');
    _this.button_.title = tipLabel;

    _this.button_.setAttribute('type', 'button');

    _this.button_.appendChild(_this.labelNode_);

    _this.button_.addEventListener(_EventType["default"].CLICK, _this.handleClick_.bind(_this), false);

    _this.setClassName_(_this.button_, _this.isInFullscreen_);

    _this.element.className = "".concat(_this.cssClassName_, " ").concat(_css.CLASS_UNSELECTABLE, " ").concat(_css.CLASS_CONTROL);

    _this.element.appendChild(_this.button_);

    return _this;
  }
  /**
   * @param {MouseEvent} event The event to handle
   * @private
   */


  FullScreen.prototype.handleClick_ = function (event) {
    event.preventDefault();
    this.handleFullScreen_();
  };
  /**
   * @private
   */


  FullScreen.prototype.handleFullScreen_ = function () {
    var map = this.getMap();

    if (!map) {
      return;
    }

    var doc = map.getOwnerDocument();

    if (!isFullScreenSupported(doc)) {
      return;
    }

    if (isFullScreen(doc)) {
      exitFullScreen(doc);
    } else {
      var element = void 0;

      if (this.source_) {
        element = typeof this.source_ === 'string' ? doc.getElementById(this.source_) : this.source_;
      } else {
        element = map.getTargetElement();
      }

      if (this.keys_) {
        requestFullScreenWithKeys(element);
      } else {
        requestFullScreen(element);
      }
    }
  };
  /**
   * @private
   */


  FullScreen.prototype.handleFullScreenChange_ = function () {
    var map = this.getMap();

    if (!map) {
      return;
    }

    var wasInFullscreen = this.isInFullscreen_;
    this.isInFullscreen_ = isFullScreen(map.getOwnerDocument());

    if (wasInFullscreen !== this.isInFullscreen_) {
      this.setClassName_(this.button_, this.isInFullscreen_);

      if (this.isInFullscreen_) {
        (0, _dom.replaceNode)(this.labelActiveNode_, this.labelNode_);
        this.dispatchEvent(FullScreenEventType.ENTERFULLSCREEN);
      } else {
        (0, _dom.replaceNode)(this.labelNode_, this.labelActiveNode_);
        this.dispatchEvent(FullScreenEventType.LEAVEFULLSCREEN);
      }

      map.updateSize();
    }
  };
  /**
   * @param {HTMLElement} element Target element
   * @param {boolean} fullscreen True if fullscreen class name should be active
   * @private
   */


  FullScreen.prototype.setClassName_ = function (element, fullscreen) {
    var _a, _b, _c, _d;

    if (fullscreen) {
      (_a = element.classList).remove.apply(_a, this.inactiveClassName_);

      (_b = element.classList).add.apply(_b, this.activeClassName_);
    } else {
      (_c = element.classList).remove.apply(_c, this.activeClassName_);

      (_d = element.classList).add.apply(_d, this.inactiveClassName_);
    }
  };
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  FullScreen.prototype.setMap = function (map) {
    var oldMap = this.getMap();

    if (oldMap) {
      oldMap.removeChangeListener(_MapProperty["default"].TARGET, this.boundHandleMapTargetChange_);
    }

    _super.prototype.setMap.call(this, map);

    this.handleMapTargetChange_();

    if (map) {
      map.addChangeListener(_MapProperty["default"].TARGET, this.boundHandleMapTargetChange_);
    }
  };
  /**
   * @private
   */


  FullScreen.prototype.handleMapTargetChange_ = function () {
    var listeners = this.documentListeners_;

    for (var i = 0, ii = listeners.length; i < ii; ++i) {
      (0, _events.unlistenByKey)(listeners[i]);
    }

    listeners.length = 0;
    var map = this.getMap();

    if (map) {
      var doc = map.getOwnerDocument();

      if (isFullScreenSupported(doc)) {
        this.element.classList.remove(_css.CLASS_UNSUPPORTED);
      } else {
        this.element.classList.add(_css.CLASS_UNSUPPORTED);
      }

      for (var i = 0, ii = events.length; i < ii; ++i) {
        listeners.push((0, _events.listen)(doc, events[i], this.handleFullScreenChange_, this));
      }

      this.handleFullScreenChange_();
    }
  };

  return FullScreen;
}(_Control["default"]);
/**
 * @param {Document} doc The root document to check.
 * @return {boolean} Fullscreen is supported by the current platform.
 */


function isFullScreenSupported(doc) {
  var body = doc.body;
  return !!(body['webkitRequestFullscreen'] || body['msRequestFullscreen'] && doc['msFullscreenEnabled'] || body.requestFullscreen && doc.fullscreenEnabled);
}
/**
 * @param {Document} doc The root document to check.
 * @return {boolean} Element is currently in fullscreen.
 */


function isFullScreen(doc) {
  return !!(doc['webkitIsFullScreen'] || doc['msFullscreenElement'] || doc.fullscreenElement);
}
/**
 * Request to fullscreen an element.
 * @param {HTMLElement} element Element to request fullscreen
 */


function requestFullScreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element['msRequestFullscreen']) {
    element['msRequestFullscreen']();
  } else if (element['webkitRequestFullscreen']) {
    element['webkitRequestFullscreen']();
  }
}
/**
 * Request to fullscreen an element with keyboard input.
 * @param {HTMLElement} element Element to request fullscreen
 */


function requestFullScreenWithKeys(element) {
  if (element['webkitRequestFullscreen']) {
    element['webkitRequestFullscreen']();
  } else {
    requestFullScreen(element);
  }
}
/**
 * Exit fullscreen.
 * @param {Document} doc The document to exit fullscren from
 */


function exitFullScreen(doc) {
  if (doc.exitFullscreen) {
    doc.exitFullscreen();
  } else if (doc['msExitFullscreen']) {
    doc['msExitFullscreen']();
  } else if (doc['webkitExitFullscreen']) {
    doc['webkitExitFullscreen']();
  }
}

var _default = FullScreen;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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